import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { otRuleCreateTourSteps } from "./otRuleCreateTourSteps";
import { useOvertimeTour } from "./useOvertimeTour";

const TOUR_STORAGE_KEY = "hr-overtime-rule-create-tour-completed";

type OTRuleCreateTourProps = {
  run: boolean;
  onCallback: (data: { status?: string; type?: string; index?: number }) => void;
};

export function OTRuleCreateTour({ run, onCallback }: OTRuleCreateTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={otRuleCreateTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useOTRuleCreateTour() {
  return useOvertimeTour(TOUR_STORAGE_KEY);
}
